import React, { useCallback, useEffect, useState } from 'react';
import { ui, STATUS_COLOR, STATUS_LABEL } from './ui';
import { CLASS_LIST, difficultyMix, paperTotal } from './paperUtils';
import { listPapers, setPaperStatus, deletePaper, errMsg } from './paperApi';

// Teacher: own papers. Principal: every paper school-wide with review/moderation controls.
export default function PapersList({ user, isPrincipal, onOpen, refreshKey }) {
  const [papers, setPapers] = useState([]);
  const [f, setF] = useState({ classId: '', status: '', role: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState('');

  const load = useCallback(() => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    listPapers(user, params).then((p) => { setPapers(p); setErr(''); }).catch((e) => setErr(errMsg(e)));
  }, [user, f]);
  useEffect(() => { load(); }, [load, refreshKey]);

  const act = async (id, fn) => {
    setBusy(id);
    try { await fn(); load(); } catch (e) { setErr(errMsg(e)); }
    setBusy('');
  };

  return (
    <div>
      <div style={ui.row}>
        <select style={{ ...ui.input, width: 'auto' }} value={f.classId} onChange={(e) => setF({ ...f, classId: e.target.value })}>
          <option value="">All classes</option>{CLASS_LIST.map((c) => <option key={c} value={c}>Class {c}</option>)}
        </select>
        <select style={{ ...ui.input, width: 'auto' }} value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })}>
          <option value="">All statuses</option>{Object.entries(STATUS_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        {isPrincipal && (
          <select style={{ ...ui.input, width: 'auto' }} value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })}>
            <option value="">Teachers + Principal</option><option value="teacher">Teacher papers</option><option value="principal">Principal papers</option>
          </select>
        )}
        <button type="button" style={ui.btn} onClick={load}>Refresh</button>
      </div>
      {err && <div style={ui.err}>{err}</div>}
      {!papers.length && <div style={{ padding: 16, color: '#94a3b8', fontSize: 13 }}>No papers found.</div>}
      {papers.map((p) => {
        const secs = p.sections || [];
        const total = paperTotal(secs);
        const mix = difficultyMix(secs);
        const mismatch = p.maxMarksLocked && total !== p.maxMarks;
        const qCount = secs.reduce((a, s) => a + (s.questions || []).length, 0);
        return (
          <div key={p._id} style={ui.card}>
            <div style={ui.row}>
              <b style={{ fontSize: 14 }}>{p.title}</b>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: STATUS_COLOR[p.status], padding: '2px 8px', borderRadius: 10 }}>{STATUS_LABEL[p.status]}</span>
              {p.readyForPrint && <span style={{ fontSize: 11, fontWeight: 700, color: '#166534', background: '#dcfce7', padding: '2px 8px', borderRadius: 10 }}>Ready for print</span>}
            </div>
            <div style={{ fontSize: 12, color: '#475569', margin: '4px 0' }}>
              Class {p.classId}{p.section ? `-${p.section}` : ''} · {p.subject} · {qCount} questions · by {p.createdByName || p.role} ({p.role}) · {new Date(p.updatedAt).toLocaleDateString()}
            </div>
            <div style={{ fontSize: 12 }}>
              Marks: <b style={{ color: mismatch ? '#b91c1c' : '#0f172a' }}>{total}</b>{p.maxMarksLocked ? ` / ${p.maxMarks}${mismatch ? ' ⚠ mismatch' : ''}` : ''}
              {' · '}Difficulty (marks): Easy {mix.easy} · Medium {mix.medium} · Hard {mix.hard}{mix.untagged ? ` · Untagged ${mix.untagged}` : ''}
            </div>
            <div style={{ ...ui.row, marginTop: 8 }}>
              <button type="button" style={ui.btn} onClick={() => onOpen(p._id)}>{isPrincipal ? 'Review / Edit' : 'Open'}</button>
              {isPrincipal && p.status !== 'approved' && <button type="button" style={ui.btnGreen} disabled={busy === p._id} onClick={() => act(p._id, () => setPaperStatus(user, p._id, { status: 'approved' }))}>✔ Approve for exam</button>}
              {isPrincipal && p.status === 'approved' && <button type="button" style={ui.btn} disabled={busy === p._id} onClick={() => act(p._id, () => setPaperStatus(user, p._id, { status: 'draft' }))}>Revoke approval</button>}
              {p.status !== 'archived' && <button type="button" style={ui.btn} disabled={busy === p._id} onClick={() => act(p._id, () => setPaperStatus(user, p._id, { status: 'archived' }))}>Archive</button>}
              {p.status === 'archived' && <button type="button" style={ui.btn} disabled={busy === p._id} onClick={() => act(p._id, () => setPaperStatus(user, p._id, { status: 'draft' }))}>Restore</button>}
              <button type="button" style={{ ...ui.btnDanger, marginLeft: 'auto' }} disabled={busy === p._id} onClick={() => { if (window.confirm(`Delete "${p.title}"?`)) act(p._id, () => deletePaper(user, p._id)); }}>Delete</button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
